export const congratulations=[
    "https://media.giphy.com/media/3oz9ZE2Oo9zRC/giphy.gif",
    "https://giphy.com/clips/studiosoriginals-teddy-too-big-lvG3xtCyb07PWjVoj0",
    "https://media.giphy.com/media/3oz9ZE2Oo9zRC/giphy.gif",
    "https://media.giphy.com/media/Srf1W4nnQIb0k/giphy.gif",
    "https://media.giphy.com/media/Srf1W4nnQIb0k/giphy.gif",
    "https://media.giphy.com/media/Srf1W4nnQIb0k/giphy.gif",
    "https://media.giphy.com/media/Srf1W4nnQIb0k/giphy.gif",
    "https://media.giphy.com/media/Srf1W4nnQIb0k/giphy.gif",
    "https://media.giphy.com/media/Srf1W4nnQIb0k/giphy.gif",
    "https://media.giphy.com/media/Srf1W4nnQIb0k/giphy.gif",
    "https://media.giphy.com/media/Srf1W4nnQIb0k/giphy.gif"
]   